<template>
</template>
<script>
export default {
    props: {
        message: {
            type: String,
            default: 'Erreur'
        }
    },
    mounted() {
        this.$alert(this.message, '', {
            iconClass: 'el-icon-warning',
            dangerouslyUseHTMLString: true
        });
    }
}
</script>
